var _desc, _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgXmqLogoWide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 72",
    width: 300,
    height: 72,
    role: "img",
    "aria-label": "XMQ, built on SPTK",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "XMQ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "XMQ in relief. The shadow it casts spells SPTK - the toolkit it is built on.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "xmq",
    d: "M 59.765625,75.351562 90.117187,120 H 66.621094 L 46.171875,90.117187 25.898437,120 H 2.2851563 L 32.636719,75.351562 3.4570313,32.519531 H 27.011719 L 46.171875,60.703125 65.273437,32.519531 H 88.945312 Z M 105.53516,32.519531 h 28.71093 l 19.92188,46.816406 20.03906,-46.816406 h 28.65234 V 120 H 181.53125 V 56.015625 L 161.375,103.18359 H 147.07812 L 126.92188,56.015625 V 120 H 105.53516 Z M 269.3125,121.58203 h -1.75781 q -21.6211,0 -33.63282,-11.95312 -12.01171,-11.953129 -12.01171,-33.281254 0,-21.269531 11.95312,-33.339844 Q 245.875,30.9375 266.91016,30.9375 q 21.26953,0 33.10546,11.953125 11.89454,11.953125 11.89454,33.457031 0,14.765625 -6.32813,25.429684 -6.26953,10.66407 -18.10547,16.05469 l 17.63672,19.6875 h -21.50391 z m -2.40234,-74.296874 q -10.3125,0 -15.9961,7.617188 -5.68359,7.617187 -5.68359,21.445312 0,14.0625 5.5664,21.5625 5.56641,7.441404 16.11329,7.441404 10.37109,0 16.05468,-7.617185 5.6836,-7.617188 5.6836,-21.386719 0,-13.828125 -5.6836,-21.445312 -5.68359,-7.617188 -16.05468,-7.617188 z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "sptk",
    d: "m 71.894531,175.27344 v 18.51562 q -7.207031,-3.22265 -14.0625,-4.86328 -6.855469,-1.64062 -12.949219,-1.64062 -8.085937,0 -11.953125,2.22656 -3.867187,2.22656 -3.867187,6.91406 0,3.51563 2.578125,5.50781 2.636719,1.9336 9.492187,3.33985 l 9.609375,1.93359 q 14.589844,2.92969 20.742188,8.90625 6.152344,5.97656 6.152344,16.99219 0,14.47265 -8.613282,21.5625 -8.554687,7.03125 -26.191406,7.03125 -8.320312,0 -16.699219,-1.58203 -8.378906,-1.58203 -16.757812,-4.6875 v -19.04297 q 8.378906,4.45312 16.171875,6.73828 7.851562,2.22656 15.117187,2.22656 7.382813,0 11.308594,-2.46094 3.925781,-2.46093 3.925781,-7.03125 0,-4.10156 -2.695312,-6.32812 -2.636719,-2.22656 -10.605469,-3.98438 l -8.730469,-1.93359 q -13.125,-2.8125 -19.218749,-8.96484 -6.0351567,-6.15235 -6.0351567,-16.58203 0,-13.06641 8.4374997,-20.09766 8.4375,-7.03125 24.257813,-7.03125 7.207031,0 14.824218,1.11328 7.617188,1.05469 15.761719,3.22266 z m 31.546879,-2.75391 h 37.4414 q 16.69922,0 25.60547,7.44141 8.96484,7.38281 8.96484,21.09375 0,13.76953 -8.96484,21.21093 -8.90625,7.38282 -25.60547,7.38282 H 126 V 260 H 103.44141 Z M 126,188.86719 v 24.43359 h 12.48047 q 6.5625,0 10.13672,-3.16406 3.57422,-3.22266 3.57422,-9.08203 0,-5.85938 -3.57422,-9.02344 -3.57422,-3.16406 -10.13672,-3.16406 z m 60.96094,-16.34766 h 80.625 v 17.05078 H 238.58203 V 260 h -22.55859 v -70.42969 h -29.0625 z m 98.28515,0 h 22.5586 v 31.93359 l 32.51953,-31.93359 h 26.1914 L 324.38672,213.94531 370.85156,260 H 342.60937 L 307.80469,225.54687 V 260 h -22.5586 z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(19.98,-12.00) skewX(-14) scale(0.52,0.3)",
    opacity: 0.34
  }, /*#__PURE__*/React.createElement("use", {
    href: "#sptk",
    fill: "#131B24"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(18.74,-9.02) scale(0.55)"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 4.4,
    y: 4.4,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 3.85,
    y: 3.85,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 3.3,
    y: 3.3,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 2.75,
    y: 2.75,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 2.2,
    y: 2.2,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 1.65,
    y: 1.65,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 1.1,
    y: 1.1,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: 0.55,
    y: 0.55,
    fill: "#26313E"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    fill: "#F4F8FC"
  }), /*#__PURE__*/React.createElement("use", {
    href: "#xmq",
    x: -1.4,
    y: -1.4,
    fill: "#CBDDEF",
    opacity: 0.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmqLogoWide);
export default __webpack_public_path__ + "static/media/xmq_logo_wide.8c8c7f8e9ff587282cf55cd4a3981df7.svg";
export { ForwardRef as ReactComponent };